module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/title_event-b386885a9c40a688a9addcf898f90a0f.svg";